import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { LayoutContainerProps } from 'types';

const useStyles = makeStyles(() => ({
  '@media print': {
    root: { backgroundColor: 'white !important' }
  },
  root: {
    height: '100%',
    backgroundColor: '#EEEEEE'
  }
}));

const LayoutContainer: React.FC<LayoutContainerProps> = ({
  NavBar,
  AppBar,
  id,
  getTitle,
  children,
  ...routeConfigProps
}): React.ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation(id);

  return (
    <div className={classes.root}>
      {AppBar && (
        <AppBar id={id} getTitle={(): string => t(getTitle() ?? '')} {...routeConfigProps} />
      )}
      {NavBar && <NavBar id={id} getTitle={getTitle} {...routeConfigProps} />}
      {/* ...other route-level-layout components... */}
      {children}
    </div>
  );
};

export default LayoutContainer;
